<script lang="ts">
    import { Breadcrumb } from 'breadcrumb'
    import { groups as ugroups } from 'hydria/services/session'

    import DomActivationBlock from './DomActivationBlock.svelte'
    import EventsBlock from './EventsBlock.svelte'
    import NsdServerStatusBlock from './NsdServerStatusBlock.svelte'
    import OrderStatusBlock from './OrderStatusBlock.svelte'
    import RunningTasks from './RunningTasks.svelte'
    import StageOfLifeBlock from './StageOfLifeBlock.svelte'
    import TaskStatsBlock from './TaskStatsBlock.svelte'
    import ZoneStatusCountsBlock from './ZoneStatusCountsBlock.svelte'

    // import QrCreator from 'qr-creator'
    // import { onMount } from 'svelte'

    // let yo: HTMLDivElement

    // onMount(() => {
    //     if (!yo) {
    //         console.error('no yo')
    //         return
    //     }
    //     QrCreator.render(
    //         {
    //             text: 'allo',
    //             radius: 0,
    //             ecLevel: 'H',
    //             background: '#ffffff',
    //             size: 96,
    //         },
    //         yo,
    //     )
    // })
</script>

<Breadcrumb />

<!-- <div class="row mb-4">
    <div class="col-sm-6">
        <div bind:this={yo}></div>
    </div>
</div> -->

<div class="row">
    <div class="col-sm-6 d-grid gap-4">
        <EventsBlock />
        {#if $ugroups.has('global-domain-admin')}
            <TaskStatsBlock />
            <RunningTasks />
        {/if}

        {#if $ugroups.has('zone-servers')}
            <NsdServerStatusBlock />
        {/if}

        {#if $ugroups.has('zone-management')}
            <ZoneStatusCountsBlock />
        {/if}
    </div>

    <div class="col-sm-6 d-grid gap-4">
        {#if $ugroups.has('global-domain-admin')}
            <DomActivationBlock />
        {/if}

        {#if $ugroups.has('global-ecom-admin')}
            <OrderStatusBlock />
        {/if}

        {#if $ugroups.has('global-domain-admin')}
            <StageOfLifeBlock />
        {/if}
    </div>
</div>
